function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { motion } from 'framer-motion';
var pageStyle = {
  width: "100%",
  height: "100%",
  display: "inline-block",
  flex: "none"
};

var Slider = _ref => {
  var {
    x,
    i,
    onDragEnd,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(motion.div, {
    style: _extends({}, pageStyle, {
      x,
      left: i * 100 + "%",
      right: i * 100 + "%"
    }),
    drag: "x",
    dragElastic: 0.3,
    onDragEnd: onDragEnd
  }, children);
};

export default Slider;